import React, { useContext } from "react";
import { ParentType } from "../../../../types/GlobalType";
import { parentContext } from "../../../../context/AppContext";

const ParentAddress = () => {
  const parentData: ParentType = useContext(parentContext);

  return (
    <div className="tuteur_info">
      <h4 className="title_section">Adresse résidentielle</h4>
      <table>
        <tr>
          <td>Avenue:</td>
          <td>{parentData.avenue?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Quartier:</td>
          <td>{parentData.quartier?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Commune:</td>
          <td>{parentData.commune?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Ville:</td>
          <td>{parentData.ville?.toUpperCase()}</td>
        </tr>
        {/* <tr>
          <td>Téléphone:</td>
          <td>{parentData.telephone?.toUpperCase()}</td>
        </tr> */}
      </table>
      {/* 
      <h4 className="title_section_2">Résidence</h4>
      <table>
        <tr>
          <td>Avenue:</td>
          <td>De la Conference</td>
        </tr>
        <tr>
          <td>Quartier:</td>
          <td>Kyeshero</td>
        </tr>
        <tr>
          <td>Commune:</td>
          <td>Goma</td>
        </tr>
        <tr>
          <td>Ville:</td>
          <td>Goma</td>
        </tr>
      </table> */}
    </div>
  );
};

export default ParentAddress;
